export default __webpack_public_path__ + "static/Drift-138a0f67763c97aa998e835a15eb161c.png";